

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PatientAcquisitionExportationFrameComments extends Vue {
  @Prop({ required: true }) private height!: number;
  @Prop({ required: true }) private comment!: string;
  @Prop({ required: true }) private actions!: string;
  @Prop(Boolean) protected vertical!: boolean;

  get _comment() {
    return this.comment;
  }

  set _comment(value: string) {
    this.$emit('update:comment', value);
  }

  get _actions() {
    return this.actions;
  }

  set _actions(value: string) {
    this.$emit('update:actions', value);
  }
}
